import React from "react";

function getCurrentPath() {
	const publicUrl = process.env.PUBLIC_URL || "";
	const pathname = window.location.pathname;

	if (publicUrl && pathname.startsWith(publicUrl)) {
		return pathname.slice(publicUrl.length) || "/";
	}

	return pathname || "/";
}

export default function App() {
	const [path, setPath] = React.useState(getCurrentPath());

	React.useEffect(() => {
		const handleLocationChange = () => setPath(getCurrentPath());
		window.addEventListener("popstate", handleLocationChange);
		return () => window.removeEventListener("popstate", handleLocationChange);
	}, []);

	let ActivePage = window.AppPages.HomePage;

	if (path === "/buy-now") {
		ActivePage = window.AppPages.BuyNowPage;
	} else if (path === "/vehicle-details") {
		ActivePage = window.AppPages.VehicleQuotePage;
	} else if (path === "/quotes") {
		ActivePage = window.AppPages.QuotesResultsPage;
	} else if (path === "/agent-dashboard") {
		ActivePage = window.AppPages.AgentDashboardPage;
	}

	return (
		<>
			<ActivePage />
			<div className="px-4 pb-6 text-center text-sm font-medium text-slate-500 md:px-6">
				Designed &amp; Developed by VRSamadhan Tech Solution
			</div>
		</>
	);
}
